import React, { createContext, useContext, useEffect, useState } from 'react';
import { getGeo } from '../services/api';
import { DEFAULT_REGION, regionByCode } from '../services/regions';

// Persisted user choice. Its mere PRESENCE means "the user picked a region" — so
// we never auto-override it with IP detection on later visits ("user choice wins").
const STORAGE_KEY = 'wtb_region';

const RegionContext = createContext({ region: DEFAULT_REGION, setRegion: () => {} });

export const useRegion = () => useContext(RegionContext);

export function RegionProvider({ children }) {
  const [region, setRegionState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || DEFAULT_REGION; } catch { return DEFAULT_REGION; }
  });

  // Explicit user selection — persist so it always wins on future visits.
  const setRegion = (code) => {
    setRegionState(code);
    try { localStorage.setItem(STORAGE_KEY, code); } catch { /* private mode */ }
  };

  // First-visit auto-detect: only when the user has made no explicit choice yet.
  // We set state but DON'T persist — it's a soft default the user can override.
  useEffect(() => {
    try { if (localStorage.getItem(STORAGE_KEY)) return; } catch { return; }
    let alive = true;
    getGeo()
      .then((country) => {
        if (!alive || !country) return;
        try { if (localStorage.getItem(STORAGE_KEY)) return; } catch { /* ignore */ }
        const match = regionByCode(country);
        if (match) setRegionState(match.code);
      })
      .catch(() => { /* fall back to Worldwide */ });
    return () => { alive = false; };
  }, []);

  return <RegionContext.Provider value={{ region, setRegion }}>{children}</RegionContext.Provider>;
}
